const basePath = "storage/";

export const storage = {
  // ==========================
  // 2️⃣ Storage
  // ==========================
  id: 2,
  category: "Storage",

  filters: {
    Brand: { type: "checkbox" },
    Model: { type: "checkbox" },
    Type: { type: "checkbox" },
    Processor: { type: "checkbox" },
    Memory: { type: "checkbox" },
    "Storage Bays": { type: "checkbox" },
    "Max Capacity": { type: "checkbox" },
  },

  subcategories: [
    {
      name: "Dell EMC PowerVault ME4024",
      bestSeller: true,
      image: `${basePath}Dell_EMC_PowerVault_ME4024.png`,
      details: {
        Brand: "Dell EMC",
        Model: "PowerVault ME4024",
        Type: "Hybrid Storage Array",
        Processor: "Dual Controller",
        Memory: "16GB Cache per Controller",
        "Storage Bays": '24 x 2.5" SSD/HDD',
        "Max Capacity": "Up to 576TB (24x24TB drives)",
      },
      about: `
        <ul>
          <li>Enterprise-grade hybrid storage array combining SSD and HDD performance</li>
          <li>Dual controller architecture for high availability and failover</li>
          <li>16GB cache per controller enabling high IOPS for database workloads</li>
          <li>Supports SSD and HDD tiering for cost-optimized performance</li>
          <li>Ideal for virtualization, databases, and mixed workload environments</li>
          <li>Thin provisioning and snapshots for efficient storage utilization</li>
          <li>iSCSI and Fibre Channel connectivity options</li>
          <li>Replication for disaster recovery and data protection</li>
          <li>Active-active redundancy for zero downtime maintenance</li>
          <li>Dell EMC management console for simplified operations</li>
          <li>Excellent performance per watt and power efficiency</li>
        </ul>
      `,
    },
    {
      name: "Dell EMC Unity XT 380",
      bestSeller: false,
      image: `${basePath}HPE_3PAR_StoreServ_7450.png`, // No matching file given → NOT replaced
      details: {
        Brand: "Dell EMC",
        Model: "Unity XT 380",
        Type: "Unified Storage Array",
        Processor: "Dual Storage Controllers",
        Memory: "Up to 256GB Cache",
        "Storage Bays": "Up to 200 drives",
        "Max Capacity": "Up to 25PB (Block & File Combined)",
      },
      about: `
        <ul>
          <li>Unified block and file storage platform for converged infrastructure</li>
          <li>Optimized for virtualization (vSphere, Hyper-V) and database workloads</li>
          <li>High availability active-active design with redundant controllers</li>
          <li>Support for NFS, SMB/CIFS, iSCSI, and Fibre Channel protocols</li>
          <li>Advanced data services: snapshots, replication, deduplication</li>
          <li>Up to 256GB cache for superior performance</li>
          <li>Scalable architecture supporting mixed storage tiers</li>
          <li>Dell EMC RecoverPoint integration for advanced DR</li>
          <li>Cloud-connected with AWS and Azure hybrid capabilities</li>
          <li>Dell Unisphere for multi-array management</li>
          <li>Industry-leading performance for enterprise deployments</li>
        </ul>
      `,
    },
    {
      name: "HPE MSA 2060 Storage Array",
      bestSeller: true,
      image: `${basePath}HPE_3PAR_StoreServ_8000.png`, // No matching file given → NOT replaced
      details: {
        Brand: "HPE",
        Model: "MSA 2060",
        Type: "Hybrid Storage Array",
        Processor: "Dual Controller",
        Memory: "16GB Cache",
        "Storage Bays": "24 SFF or 12 LFF drives",
        "Max Capacity": "Up to 576TB (24x24TB drives)",
      },
      about: `
        <ul>
          <li>Next-generation hybrid storage array from HPE for high-performance workloads</li>
          <li>Ideal for SMB and mid-size businesses with growth requirements</li>
          <li>Flexible drive bays supporting SAS, SATA, and NVMe</li>
          <li>Dual controller architecture for redundancy and load balancing</li>
          <li>16GB dedicated cache per controller for exceptional IOPS</li>
          <li>Supports iSCSI and Fibre Channel connectivity</li>
          <li>Advanced features: thin provisioning, snapshots, remote replication</li>
          <li>Integrated HPE One-View management with intuitive web interface</li>
          <li>Superior reliability with enterprise-grade components</li>
          <li>Excellent value proposition for mid-market storage deployments</li>
          <li>Power-efficient design with optimized thermal management</li>
        </ul>
      `,
    },
    {
      name: "HPE StoreEasy 1660 File Storage",
      bestSeller: false,
      image: `${basePath}HPE_StoreEasy_1660.png`,
      details: {
        Brand: "HPE",
        Model: "StoreEasy 1660",
        Type: "File Storage Appliance",
        Processor: "Intel Xeon",
        Memory: "32GB DDR4",
        "Storage Bays": "Up to 28 LFF drives",
        "Max Capacity": "Up to 672TB (28x24TB drives)",
      },
      about: `
        <ul>
          <li>File storage appliance optimized for SMB and departmental backup</li>
          <li>Powered by HPE ProLiant technology and reliability</li>
          <li>Supports up to 28 large-form-factor drive bays for high capacity</li>
          <li>NFS and SMB/CIFS protocols for broad client support</li>
          <li>Integrated backup software and data protection features</li>
          <li>Efficient data deduplication reducing storage consumption</li>
          <li>Snapshot capabilities for point-in-time recovery</li>
          <li>Scalable to enterprise levels with clustering support</li>
          <li>Simple management through intuitive web console</li>
          <li>Energy-efficient architecture with dual power supplies</li>
          <li>Ideal for file server consolidation and backup projects</li>
        </ul>
      `,
    },
    {
      name: "Lenovo ThinkSystem DE4000H Storage",
      bestSeller: true,
      image: `${basePath}Lenovo_ThinkSystem_DE4000H.png`,
      details: {
        Brand: "Lenovo",
        Model: "ThinkSystem DE4000H",
        Type: "Hybrid Storage Array",
        Processor: "Dual Controller",
        Memory: "Up to 128GB Cache",
        "Storage Bays": "Up to 120 drives",
        "Max Capacity": "Up to 2PB (Mixed SSD/HDD)",
      },
      about: `
        <ul>
          <li>Enterprise hybrid flash storage with high availability architecture</li>
          <li>Supports iSCSI, SAS, and Fibre Channel protocols</li>
          <li>Up to 128GB cache per controller for extreme performance</li>
          <li>Flexible storage configuration: SSD, SAS, and SATA drives</li>
          <li>Active-active dual controller for zero downtime maintenance</li>
          <li>Advanced features: thin provisioning, snapshots, replication</li>
          <li>Lenovo XClarity management for simplified administration</li>
          <li>Cloud-ready with hybrid and multi-cloud connectivity</li>
          <li>Proven reliability in enterprise data center environments</li>
          <li>Excellent performance-to-capacity ratio</li>
          <li>Compatible with industry-standard virtualization platforms</li>
        </ul>
      `,
    },
    {
      name: "NetApp FAS2720 Storage Controller",
      bestSeller: true,
      image: `${basePath}HPE 3PAR StoreServ 7400.jpg`, // Not in list, kept same style
      details: {
        Brand: "NetApp",
        Model: "FAS2720",
        Type: "Unified NAS/SAN Storage",
        Processor: "Dual Controller",
        Memory: "32GB Cache",
        "Storage Bays": "12 LFF or 24 SFF drives",
        "Max Capacity": "Up to 576TB (24x24TB drives)",
      },
      about: `
        <ul>
          <li>NetApp's mid-range unified NAS and SAN storage system</li>
          <li>Excellent for backup, file services, and block storage workloads</li>
          <li>ONTAP operating system providing advanced data management</li>
          <li>Supports NFS, SMB/CIFS, iSCSI, and Fibre Channel</li>
          <li>Integrated snapshots and SnapMirror for disaster recovery</li>
          <li>Data deduplication and compression for efficient utilization</li>
          <li>NetApp Data Fabric for seamless hybrid cloud integration</li>
          <li>Superior performance with 32GB cache per controller</li>
          <li>Flexible drive options: SAS, SATA, NVMe</li>
          <li>Proven reliability with enterprise-class features</li>
          <li>Great for organizations requiring unified storage infrastructure</li>
        </ul>
      `,
    },
    {
      name: "Synology RackStation RS4021xs+ NAS",
      bestSeller: true,
      image: `${basePath}HPE_3PAR_StoreServ_20000.png`, // No matching file → placeholder
      details: {
        Brand: "Synology",
        Model: "RackStation RS4021xs+",
        Type: "Enterprise NAS Appliance",
        Processor: "Intel Xeon D-1541",
        Memory: "16GB ECC RAM (expandable to 128GB)",
        "Storage Bays": '16 x 3.5" SATA bays',
        "Max Capacity": "Up to 384TB (16x24TB drives)",
      },
      about: `
        <ul>
          <li>Enterprise NAS appliance with virtualization support</li>
          <li>Intel Xeon processor for professional-grade performance</li>
          <li>16 large-capacity drive bays ideal for high-volume storage</li>
          <li>DiskStation Manager (DSM) operating system with rich features</li>
          <li>Support for NFS, SMB/CIFS, and HTTP protocols</li>
          <li>Built-in virtualization with VMware vSAN support</li>
          <li>Advanced snapshot and replication capabilities</li>
          <li>Redundant power supplies and dual network adapters</li>
          <li>Data deduplication for storage efficiency</li>
          <li>10Gb Ethernet support for enterprise networking</li>
          <li>Designed for reliable high-volume storage in corporate environments</li>
        </ul>
      `,
    },
    {
      name: "QNAP TS-1685-D1531-64G Enterprise NAS",
      bestSeller: false,
      image: `${basePath}HPE 3PAR StoreServ 7200.jpg`, // Real filename
      details: {
        Brand: "QNAP",
        Model: "TS-1685-D1531-64G",
        Type: "Enterprise NAS Appliance",
        Processor: "Intel Xeon D-1531",
        Memory: "64GB DDR4 ECC",
        "Storage Bays": '16 x 3.5" drive bays',
        "Max Capacity": "Up to 384TB (16x24TB drives)",
      },
      about: `
        <ul>
          <li>High-performance enterprise NAS with powerful processor and memory</li>
          <li>Intel Xeon D-1531 processor for demanding workloads</li>
          <li>64GB memory enabling superior SSD caching performance</li>
          <li>Excellent for business storage and enterprise virtualization</li>
          <li>Support for NFS, SMB/CIFS, and advanced protocols</li>
          <li>Integrated SSD caching for accelerated storage performance</li>
          <li>Snapshot and incremental replication for data protection</li>
          <li>VMware vSAN ecosystem compatible</li>
          <li>10Gb Ethernet connectivity for enterprise deployments</li>
          <li>QNAP QTS operating system with comprehensive storage features</li>
          <li>Ideal for organizations requiring maximum NAS performance</li>
        </ul>
      `,
    },
    {
      name: "Pure Storage FlashArray//C",
      bestSeller: false,
      image: `${basePath}HPE 3PAR StoreServ 7400.jpg`,
      details: {
        Brand: "Pure Storage",
        Model: "FlashArray//C",
        Type: "All-Flash Array",
        Controller: "Active-Active Controllers",
        Memory: "Inline Dedup & Compression Engine",
        "Raw Capacity": "Scales from tens to petabytes",
        "Max Effective Capacity": "Vendor-dependent (with reduction)",
      },
      about: `
        <ul>
          <li>Enterprise-grade all-flash array optimized for cost-effective capacity</li>
          <li>Designed for dense flash storage with inline deduplication and compression</li>
          <li>Non-disruptive upgrades and cloud-connected support</li>
          <li>Provides predictable low latency for databases and VDI</li>
          <li>Purity Operating Environment with cloud-based monitoring (Pure1)</li>
        </ul>
      `,
    },
    {
      name: "IBM FlashSystem 5200",
      bestSeller: false,
      image: `${basePath}HPE Primera.jpg`,
      details: {
        Brand: "IBM",
        Model: "FlashSystem 5200",
        Type: "All-Flash Array",
        Controller: "IBM Spectrum Virtualize",
        Memory: "High-performance NVMe front-end",
        "Max Capacity": "Hundreds of TBs (all-flash)",
        Connectivity: "NVMe/oF, Fibre Channel, iSCSI",
      },
      about: `
        <ul>
          <li>Mid-range all-flash system delivering enterprise performance</li>
          <li>IBM Spectrum Virtualize for advanced data services and replication</li>
          <li>Supports NVMe/TCP and NVMe over Fabrics for low-latency workloads</li>
          <li>Rich data reduction, snapshots, and thin provisioning features</li>
          <li>Ideal for databases, analytics, and latency-sensitive applications</li>
        </ul>
      `,
    },
    {
      name: "NetApp AFF A250",
      bestSeller: false,
      image: `${basePath}HPE 3PAR StoreServ 7000.jpg`,
      details: {
        Brand: "NetApp",
        Model: "AFF A250",
        Type: "All-Flash Array",
        Processor: "NetApp ONTAP",
        Memory: "System cache and acceleration",
        "Storage Bays": "2U all-flash configuration",
        "Max Capacity": "Depends on drive configuration",
      },
      about: `
        <ul>
          <li>NetApp AFF series offering enterprise NVMe and flash performance</li>
          <li>ONTAP data management with inline dedupe, compression, and snapshots</li>
          <li>Seamless integration with NetApp Data Fabric and cloud tiers</li>
          <li>Optimized for databases, virtualization and cloud-native workloads</li>
        </ul>
      `,
    },
    {
      name: "Dell EMC PowerScale F200",
      bestSeller: false,
      image: `${basePath}Dell_EMC_PowerScale_F200.png`,
      details: {
        Brand: "Dell EMC",
        Model: "PowerScale F200",
        Type: "Scale-out NAS (OneFS)",
        Processor: "Dedicated storage nodes",
        Memory: "Node-local cache",
        "Storage Bays": "Dense NVMe or SSD nodes",
        "Use Case": "Unstructured data, file services",
      },
      about: `
        <ul>
          <li>PowerScale (OneFS) scale-out NAS platform for unstructured data</li>
          <li>Designed for high throughput file workloads: media, analytics, AI</li>
          <li>Scale-out architecture allows incremental expansion without downtime</li>
          <li>Integrated data protection and replication features
          </li>
        </ul>
      `,
    },
    {
      name: "HPE Primera 650",
      bestSeller: false,
      image: `${basePath}HPE_Primera_650.png`,
      details: {
        Brand: "HPE",
        Model: "Primera 650",
        Type: "Mission-Critical Storage Array",
        Processor: "HPE InfoSight integrated",
        Memory: "High-performance NVMe architecture",
        "Max Capacity": "Scalable multi-petabyte configurations",
        Connectivity: "Fibre Channel, iSCSI, NVMe-oF",
      },
      about: `
        <ul>
          <li>HPE Primera is engineered for mission-critical enterprise applications</li>
          <li>Designed for 99.9999% availability with active-active clustering</li>
          <li>InfoSight AI-driven analytics for predictive maintenance and optimization</li>
          <li>Supports NVMe and NVMe-oF for extreme performance workloads</li>
          <li>Integrated snapshot, replication, and encryption capabilities</li>
        </ul>
      `,
    },
  ],
};
